<template lang="pug">
.report 
  WebTemplate(
    pagetitle= "搜索词分析",
    tip= "搜索关键词报告帮助您了解网民在各类搜索引擎上通过搜索哪些关键词进入您的网站。你可以直观了解您网站访客的关注点，同时可以衡量各个关键词为您网站带来流量的效果，以便优化搜索推广",
    :currentTab= "currentTab",
    :compareDisabled= "compareDisabled",
    :hasCrowd="hasCrowd",
    :total= "total",
    :pg= "pg",
    :ps= "ps",
    :tablist= "tablist",
    :tableDataList= "tableDataList",
    :hasCheckBox= "hasCheckBox",
    :checkboxLength= "checkboxLength",
    :sumchecked="sumChecked",
    :sum= "sum",
    :order= "order",
    :yAxis= "yAxis",
    :legend= "legend", 
    :chartXAxis= "chartXAxis",
    :chartSeries= "chartSeries",
    @indiceChange= "indiceChange",
    @timeRangeChange="getDataWithCrowd",
    @tableUpdate= "getTableData",
    @tablesorter= "tablesorter",
    :customIndice= "customIndice",
    :twoIndiceShow= "twoIndiceShow",
    :twoIndice= "twoIndice")
    template(slot="crowd")
      CrowTags(
        :selectedCrowd="selectedCrowd",
        @showCrowd="showCrowd",
        @dropCrowd="dropCrowd",
        @openCrowd="openCrowd"
        )
    template(slot="crowd-content")
      CrowEditTemplate(v-show="crowdShow",
        :crowShowType="currentCrowdType",
        @updateCrowdList="getCrowdList",
        @updatePage="getTableData",
        @apply="applyCrowd",
        @reset="resetCrowd",
        :crowdList="crowdList"
        )

    div.nav-tabs(slot="nav-tabs")
      TabContent(
        title="主维度：",
        :tablist="tablist",
        :update="updateTab",
        :currentTab="currentTab")
        div.right-tab(slot="extentTab")
          DownloadBtn(
            :reportApi="reportApi",
            :params="query",
            :pagetitle="tableTabTitle",
            subtitle="",
            v-if="total > 0",
            style="float: right;")
          CustomIndice(
            :defaults="defaultCustomIndices"
            @change="onCustomIndiceChange")
        div(slot="common") 
          p.plan-nav
            | 选择二级维度：
            v-radio-group(
              v-model="sdim",
              name="secondaryDim",
              :options="sdimOptions",
              @change.native="sdimChange")
          p.tabAction
            button.btn.btn-primary.btn-big(
              :disabled="fetchLineChartabled",
              @click="fetchLineChartData") 绘制选定行
            Search(
              :placeholder="placeHolder",
              @doSearch="doSearch",
              :defaultValue="keyword")
  .report-content(v-show="calcLoading")
    .mask-panel
      img(src="https://p1.ssl.qhimg.com/t0173f568f185dc492d.gif")
  v-modal(:visible="isMv",
        ref="mvModal"
      )
      .modal-hd
        a.fa.fa-times.close(@click="isMv = false")
      .modal-bd
        p.text-content 使用该功能需要在网站部署360分析代码
        p.mv-container
          button.btn.btn-primary.btn-small.btn-mgr(@click="gotoSetting()") 去设置


</template>

<script>
  /* global _ */
  import Store from '../../store/store.js'
  import Mixin from '../mixin.js'
  import CrowdMixin from '../crowdmixin'
  import WebTemplate from './template'
  import CrowTags from './crowTags.vue'
  import CrowEditTemplate from './crowEditTemplate.vue'
  import CrowdTemplate from '../../component/crowdTemplate.vue'
  import { mapState, mapActions, mapGetters } from 'vuex'
  export default {
    store: Store,
    components: {
      WebTemplate,
      CrowTags,
      CrowEditTemplate,
      CrowdTemplate
    },
    mixins: [Mixin, CrowdMixin],
    data () {
      return {
        sumChecked: true,
        isMv: false,
        calcLoading: false,
        cacheVersion: '',
        timer: '',
        crowd: {},
        hasCrowd: true,
        crowdShow: false,
        selectedCrowd: [],
        crowdList: [],
        preview_crowdList: [],
        currentCrowdTab: 'system',
        currentCrowdType: 'list',
        keyword: '',
        chartResList: [],
        hasCheckBox: true,
        checkboxLength: 3,
        total: 0,
        pg: 1,
        ps: 10,
        sdim: 'null',
        currentTab: 'all_keyword',
        isasc: 0,
        order: 'pv',
        legend: [],
        yAxis: [],
        tablist: [
          {
            id: 'all_keyword',
            name: '全网搜索词',
            order: 'pv',
            reportTableApi: '/api/report/keyword?groupby=keyword&ptype=all_keyword',
            basicSummaryStatApi: '/api/report/keyword?groupby=keyword&issum=1&ptype=all_keyword',
            reportLineChartApi: '/api/report/keyword?groupby=keyword&ptype=all_keyword'
          },
          {
            id: 'se360_keyword',
            name: '360搜索词',
            order: 'pv',
            reportTableApi: '/api/report/keyword?groupby=keyword&ptype=se360_keyword&refdomain=so.com',
            basicSummaryStatApi: '/api/report/keyword?groupby=keyword&issum=1&ptype=se360_keyword&refdomain=so.com',
            reportLineChartApi: '/api/report/keyword?groupby=keyword&ptype=se360_keyword&refdomain=so.com'
          }
        ],
        chartXAxis: [],
        chartSeries: [],
        customIndice: 'pv',
        twoIndice: '',
        twoIndiceShow: true,
        sum: {},
        tableDataList: [],
        defaultCustomIndices: ['pv', 'uv', 'ipnum', 'newvst', 'atime', 'tnum'],
        sdimOptions: []
      }
    },
    computed: {
      ...mapState('web', {
        tableIndices: state => state.tableIndices,
        compared: state => state.compared,
        compareStart: state => state.compareStart,
        compareEnd: state => state.compareEnd
      }),
      ...mapGetters('web', [
        'indicesMenu',
        'domainId',
        'uiError',
        'fetchLineChartabled',
        'twoIndiceSelectabled'
      ]),
      placeHolder () {
        return `请输入${_.find(this.tablist, {id: this.currentTab}).name}`
      },
      clusterid () {
        return _.map(this.selectedCrowd, item => item.id).join(',')
      },
      module () {
        return this.currentTab === 'all_keyword' ? 'keyword' : 'domain_keyword'
      },
      compareDisabled () {
        return this.selectedCrowd.length > 0
      },
      cluster () {
        return _.map(this.selectedCrowd, item => item.name).join(',')
      },
      start () {
        return this.$store.state.start
      },
      end () {
        return this.$store.state.end
      },
      tableTabTitle () {
        return `${_.find(this.tablist, {id: this.currentTab}).name}报表`
      },
      query () {
        let query = {
          isasc: this.isasc,
          order: this.order,
          domainId: this.domainId,
          pvtype: 0,
          start: this.$store.state.start,
          end: this.$store.state.end,
          cycle: this.$store.state.start === this.$store.state.end ? 'hour' : 'day',
          timespan: new Date().getTime(),
          djid: this.dianjingID,
          mdim: this.currentTab
        }
        if (this.clusterid) {
          query = _.assignIn({
            sdim: 'clusterid',
            cache_version: this.cacheVersion,
            cluster: this.cluster,
            clusterid: this.clusterid
          }, query)
        }

        if (this.sdim !== 'null') {
          query = _.assignIn({
            sdim: this.sdim
          }, query)
        }
        if (this.compared) {
          query = _.assignIn({
            compareStart: this.compareStart,
            compareEnd: this.compareEnd
          }, query)
        }
        if (this.keyword) {
          query = _.assignIn({
            keyword: this.keyword
          }, query)
        }
        return query
      },
      reportApi () {
        return _.find(this.tablist, {id: this.currentTab}).reportTableApi
      }
    },
    watch: {
      crowdShow (newVal) {
        if (newVal) {
          this.preview_crowdList = _.cloneDeep(this.crowdList)
        }
      },
      crowdGroupTabs () {
        this.currentCrowdTab = this.crowdGroupTabs[0].key
      },
      sdimOptions (newVal) {
        if (!_.has(newVal[0], 'disabled')) {
          _.map(this.sdimOptions, item => {
            this.$set(item, 'disabled', this.selectedCrowd.length > 0)
            return item
          })
        }
      },
      selectedCrowd (newVal, oldVal) {
        _.map(this.sdimOptions, item => {
          this.$set(item, 'disabled', newVal.length > 0)
          return item
        })
        this.setHistoryCrowd()
      },
      domainId () {
        // 重置人群的相关信息
        this.calcLoading = false
        clearInterval(this.timer)
        this.selectedCrowd = []
        this.crowdShow = false
        this.getCrowdList()
        this.clearKeyword()
        this.getTableData()
      },
      compared: function (newVal, oldVal) {
        this.compared = newVal
        this.resetIndice()
        if (newVal) {
          this.checkboxLength = 1
        } else {
          this.checkboxLength = 3
        }
      },
      uiError () {
        if (this.uiError.errMsg) {
          this.$Modal.warn(this.uiError.errMsg)
        }
        if (this.calcLoading) {
          this.calcLoading = false
        }
      }
    },
    created () {
      this.getHistoryCrowd()
      this.setTableIndices(this.defaultCustomIndices)
    },
    methods: {
      ...mapActions('web', {
        setTableIndices: 'SET_TABLE_INDICES',
        setCompared: 'SET_COMPARED'
      }),
      doSearch (keyword) {
        this.keyword = keyword
        this.getTableData()
      },
      onCustomIndiceChange (indices) {
        this.setTableIndices(indices)
      },
      updateTab: function (tab) {
        if (this.currentTab === tab) return
        this.resetTab(tab)
        this.keyword = ''
        this.resetIndice()
        // 重置人群数据
        if (this.calcLoading) {
          this.calcLoading = false
          clearInterval(this.timer)
        }
        // this.resetCrowd()
        this.getDataWithCrowd()
      }
    },
    destroyed () {
      clearInterval(this.timer)
    }
  }
</script>
<style scoped>
.search {
  float: right;
}
.right-tab a {
  float: left;
}
.mask-panel {
  top: 110px;
}
.modal,
.modal-bd {
  min-width: 800px;
}
.mv-container {
  text-align: center;
}
p.text-content {
    text-align: center;
    font-size: 14px;
    margin: 0 0 40px;
}
</style>



// WEBPACK FOOTER //
// keywords.vue?fdb2845a